import React from 'react';
import styles from './SidebarFooter.module.scss';
import { BrazeBannerPlaceholder } from '@/components/feedback/BrazeBannerPlaceholder/BrazeBannerPlaceholder';
import { BRAZE_CONTAINERS_IDS } from '@/constants/integrations/braze';

export const SidebarFooter: React.FC = () => {
  return (
    <div className={styles.footerBanner}>
      <BrazeBannerPlaceholder elementId={BRAZE_CONTAINERS_IDS.SIDEBAR_BOTTOM} />
    </div>
  );
};
